import React, { Component } from "react";
import { reduxForm } from "redux-form";
import PropTypes from "prop-types";
import { FormattedMessage, intlShape, injectIntl } from "react-intl";

import TextField from "modules/forms/fields/text-field";
import { validateCreatePassword } from "modules/utils/validations";

const FORM_NAME = "create-password";

class CreatePasswordForm extends Component {
  static propTypes = {
    onSubmit: PropTypes.func.isRequired,
    handleSubmit: PropTypes.func.isRequired,
    intl: intlShape.isRequired
  };

  render() {
    const { onSubmit, handleSubmit } = this.props;
    return (
      <form className="signUpForm" onSubmit={handleSubmit(onSubmit)}>
        <p>
          <FormattedMessage id="sign-up.create-password" />
        </p>
        <TextField
          name="email"
          autoComplete="email"
          label="sign-up.email"
          hidden
        />
        <TextField
          name="password1"
          placeholder="sign-up.password"
          type="password"
          autoComplete="new-password"
        />
        <TextField
          name="password2"
          placeholder="sign-up.confirm-password"
          type="password"
          autoComplete="new-password"
        />
        <button className="Button--wide" type="submit">
          <FormattedMessage id="sign-up.submit-password" />
        </button>
      </form>
    );
  }
}
export default injectIntl(
  reduxForm({ form: FORM_NAME, validate: validateCreatePassword })(
    CreatePasswordForm
  )
);



// WEBPACK FOOTER //
// ./src/modules/auth/create-password-form.js